<template>
  <section :class="{
    'style-round': cornerStyle === 'round',
    'style-square': cornerStyle === 'square',
    fontLoaded
  }">
    <button
      :style="{ fontFamily: fontFamilyCSS }"
      :class="{ multivote: showMultiVote }"
      id="btn-multivote"
      v-on:click="submit($event)"
      v-if="!(!isVoteable || votingComplete || !votingEnabled || (pollType === 'poll' && !selectedOptions.length) || next)"
    >
      {{submitButtonText}}
    </button>
  </section>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from 'vuex';
import debounce from 'lodash/debounce';

export default {
  name: 'VoteButton',
  data() {
    return {
      submit: () => {}
    };
  },
  props: {
    onVote: {
      type: Function,
      default: () => {},
    }
  },
  computed: {
    ...mapState('poll', [
      'votingEnabled',
      'votingComplete',
      'cornerStyle',
      'fontLoaded',
      'next'
    ]),
    ...mapGetters('poll', [
      'selectedOptions',
      'fontFamilyCSS',
      'isVoteable',
      'submitButtonText',
      'pollType',
      'showMultiVote',
      'captchaEnabled',
      'pollId',
      'getFeedback',
      'accountName',
      'nextLink'
    ])
  },
  methods: {
    ...mapMutations('poll', [
      'showNext'
    ]),
    ...mapActions('poll', [
      'vote',
      'submitFeedback'
    ]),
    ...mapActions('voter', [
      'registerVote'
    ]),
    async _submit(event) {
      event.preventDefault();
      let recaptchaToken = null;
      if (this.captchaEnabled) {
        await this.$recaptchaLoaded();
        recaptchaToken = await this.$recaptcha('vote');
      }
      
      if (this.pollType === 'poll') {
        this.vote({
          recaptchaToken,
          registerVote: this.registerVote
        });
      } else {
        await this.submitFeedback(recaptchaToken);
        this.registerVote({
          recaptchaToken,
          accountName: this.accountName,
          answer: this.getFeedback,
          pollId: this.pollId
        });
      }
      
      this.showNext(true);

      this.onVote();
    }
  },
  created() {
    this.submit = debounce(this._submit, 100);
  }
}
</script>

<style scoped lang="scss">
section {
  flex: 0 0 auto;
  width: 100%;
  margin: 0 !important;
  position: relative;
  z-index: 1;
}

button {
  font-size: var(--answer-fontsize);
  line-height: 1em;
  padding: 16px 20px 14px;
  text-align: center;
  border: none;
  border-radius: var(--button-radius);
  display: block;
  width: 100%;
  background-color: var(--button-bg);
  color: var(--button-color);
  cursor: pointer;
  outline: none;
  opacity: 0;
  margin-bottom: var(--answer-bottommargin);

  &:disabled {
    cursor: not-allowed;
  }
}

.isHorizontal .multivote {
  width: 20%;
  margin: 0 auto;
  min-width: 100px;
}

.style-square {

  button {
    border-radius: 4px;
  }
}

.fontLoaded {

  button {
    opacity: 1;

    &:disabled {
      opacity: 0.5;
    }
  }
}
</style>
